import React, { useState, useEffect } from "react";
import DropdownRight from "./DropdownRight";
import Nav from "../components/Nav";
import http from "../services/http";
import polygon from "../assets/images/Polygon 56.png";
import { Link, useNavigate } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import { Modal } from "react-bootstrap";
import CsvDownload from "react-json-to-csv";
import moment from "moment";
import Dropdown from "react-bootstrap/Dropdown";
import dots from "../assets/images/dots.svg";

const ShareVideo = () => {
  const token = localStorage.getItem("xAuthToken");
  const [rawVideo, setrawVideo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [toExport, setToExport] = useState([]);

  const [localSpin, setLocalSpin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    RawVideos();
  }, []);

  const RawVideos = async () => {
    setLoading(true);

    http
      .get(`api/admin/share_logs?token=${token}`)
      .then((res) => {
        console.log("response--123--->", res.data);

        setrawVideo(res.data);
        let arr = [];
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          const obj = {
            "Video Url": element.shared_video,
            "Parent Email": element.email,
            "Parent Name":
              element.firstname && element.lastname
                ? `${element.firstname + " " + element.lastname}`
                : "-",
            "Parent Phone": `'${element.phone}'`,
            "Shared With": `'${element.shared_to}'`,
            "Shared Via": element.shared_via,
            "Sharing Date": element.created_at,
          };
          arr.push(obj);
        }
        setToExport(arr);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  const WatchVideoEvo = async (id, type) => {
    setLoading(true);

    http
      .get(`api/common/video_request?token=${token}`)
      .then((res) => {
        console.log("response ------->>>>", res.data);

        navigate(`/otpLogs/${id}/${type}`);

        // setLocker(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  return (
    <>
      <div class="wrapper">
        <Nav />
        <div id="content">
          <header>
            <div class="dashboard_header">
              <div class="left-side d-flex ">
                {" "}
                <button
                  type="button"
                  id="sidebarCollapse"
                  class="btn btn-link bt_none"
                >
                  <i class="fa fa-align-left"></i>{" "}
                </button>
                <h1>Share Video</h1>
              </div>
              <div class="user_profile   ">
                <DropdownRight />
              </div>
            </div>
          </header>
          <div class="dashbord_content">
            <div class="analysts-wraper-head">
              <div class="form-group search_wraper"></div>
              <div class="map_btn" style={{ marginBottom: 30 }}>
                <CsvDownload data={toExport} className="them_btn">
                  Export
                </CsvDownload>
              </div>
            </div>
            <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
              <table class="table table-borderless table-responsive-md">
                <thead>
                  <tr>
                    {/* <th scope="col" class="  pl_25">
                      Video
                    </th> */}
                    <th scope="col" class=" ">
                      Parent_Name
                    </th>
                    <th scope="col" class=" ">
                      Parent_Email
                    </th>
                    <th scope="col" class=" ">
                      Parent_Phone
                    </th>
                    <th scope="col" class=" ">
                      Shared With
                    </th>
                    <th scope="col" class="  pl_25">
                      Shared video
                    </th>
                    <th scope="col" class="  pl_25">
                      Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <div
                      style={{
                        position: "absolute",
                        marginTop: 100,
                        // backgroundColor: "#ffffffc2",
                        marginLeft: 580,

                        // backgroundBlendMode: "overlay",
                        zIndex: 100,
                      }}
                    >
                      <SpinnerCircular size="15%" />
                    </div>
                  ) : (
                    ""
                  )}
                  {rawVideo?.map((item) => (
                    <tr>
                      {/* <Link
                        style={{
                          position: "relative",
                        }}
                        to="/video"
                        state={{
                          name: item.shared_video,
                        }}
                      >
                        <video
                          width={130}
                          height={100}
                          src={item.shared_video}
                        ></video>
                        <img
                          src={polygon}
                          alt=""
                          style={{
                            position: "absolute",
                            marginTop: 40,
                            marginLeft: -70,
                            width: 20,
                            height: 20,
                          }}
                        />
                      </Link> */}

                      <td>
                        {item.firstname} {item.lastname}
                      </td>
                      <td>{item.email}</td>
                      <td>{item.phone}</td>
                      <td>{item.shared_to}</td>
                      <td style={{ wordBreak: "break-all" }}>
                        {item.shared_video}
                      </td>
                      <td>
                        {moment(item.created_at).format("hh:mm:ss A")}
                        <br />
                        {moment(item.created_at).format("MMM Do YY")}
                      </td>

                      {/*  <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            className="btn dropdown-toggle"
                            variant="success"
                            id="dropdown-basic"
                          >
                            <img
                              src={dots}
                              className="img-fulid"
                              alt="dropdown"
                            />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item>
                              <button
                                className="btn  shadow-none"
                                onClick={() => WatchVideoEvo(item.id, "evo")}
                                style={{
                                  backgroundColor: "white",
                                }}
                              >
                                Show video
                              </button>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareVideo;
